import { useLayoutDensity, DENSITIES } from "@/lib/useLayoutDensity";
import { Rows, Square, RowsPlusBottom } from "@phosphor-icons/react";

const OPTIONS = [
  { value: "compact",  label: "Compact",  icon: Rows,             blurb: "Tighter padding — more information per screen." },
  { value: "regular",  label: "Regular",  icon: Square,           blurb: "Yadid's default rhythm — calm, editorial." },
  { value: "spacious", label: "Spacious", icon: RowsPlusBottom,   blurb: "Extra breathing room — easier for long reads." },
];

/**
 * Layout-density selector for the Settings page. Three-way toggle; each
 * option carries a short blurb so partners can pick without guessing.
 * Density is orthogonal to `font_scale` — this only changes whitespace.
 */
export default function DensityCard() {
  const { density, setDensity, syncedToServer } = useLayoutDensity();

  return (
    <div className="border border-border bg-card p-6 md:col-span-2" data-testid="density-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[0.625rem] font-mono uppercase tracking-widest text-muted-foreground flex items-center gap-1.5">
            <Square size={12} weight="bold" /> Layout density
          </div>
          <div className="mt-1 text-sm text-muted-foreground max-w-md">
            Controls padding and spacing across the app — orthogonal to reading size.
            <span className="block text-[0.625rem] font-mono uppercase tracking-widest text-eyebrow/70 mt-1" data-testid="density-sync-status">
              {syncedToServer
                ? "Synced to your profile · follows you across devices"
                : "Stored on this device (sign in to sync across devices)"}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3">
        {OPTIONS.map((opt) => {
          const Icon = opt.icon;
          const active = density === opt.value;
          return (
            <button
              key={opt.value}
              onClick={() => setDensity(opt.value)}
              data-testid={`density-option-${opt.value}`}
              className={`text-left border p-4 transition ${
                active
                  ? "border-primary bg-primary/10 text-foreground"
                  : "border-border/60 bg-secondary/20 hover:border-primary/60"
              }`}
            >
              <div className="flex items-center gap-2">
                <Icon size={16} weight={active ? "fill" : "regular"} className={active ? "text-primary" : "text-muted-foreground"} />
                <div className={`text-[0.625rem] font-mono uppercase tracking-widest ${active ? "text-eyebrow" : "text-muted-foreground"}`}>{opt.label}</div>
              </div>
              <div className="mt-1 text-sm">{opt.blurb}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
